import DoorPlateEquipment from './DoorPlateEquipment'
export default DoorPlateEquipment
